import request from "@/utils/request";
// 获取智慧管理数据
export const bigScreeIPMI = (data) =>
  request({
    headers: {
      "Content-Type": "application/json",
    },
    url: "/bigScreen/bigScreeIPMI",
    method: "POST",
    data: data,
  });
